import { INucTableItem } from '@relayter/rubber-duck';
import { autoserialize, autoserializeAs } from 'cerialize';

export class PermissionModel implements INucTableItem {
    @autoserializeAs('key') public _id: string;
    @autoserialize public name: string;
    @autoserialize public description: string;
    @autoserialize public active: boolean;

    constructor(_id: string, name?: string) {
        this._id = _id;
        this.name = name || _id;
    }
}
